import { Checkmark } from '@carbon/icons-react';
import { SxProps, useTheme } from '@mui/material';
import { Box } from '@mui/material';
import * as Preact from 'preact';

export interface Props {
    sx?: SxProps;
}

export const Component = (p: Props) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                borderRadius: '100px',
                width: '28px',
                height: '28px',
                backgroundColor: theme.palette.success.main,
                top: '6px',
                right: '6px',
                position: 'absolute',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'white',
                ...p.sx,
            }}
        >
            <Checkmark size={20} fill="white" />
        </Box>
    );
};
